import type { ISystemModule } from '@/engine/interfaces/SystemModule.ts';
import { inject, injectable } from 'inversify';
import type { HotKeysService } from '../services/HotKeys.service.ts';
import { TYPES as CORE_TYPES } from '../ioc/types.ts';
import { TYPES } from '@/engine/ioc/types.ts';
import type { CommandProcessor } from '../services/CommandProcessor.ts';
import {
  WindowKeyboardShortcutController
} from '@/engine/Controllers/windowKeyboardShortcutController/windowKeyboardShortcut.controller.ts';

@injectable()
export class CoreModule implements ISystemModule {
  private _hotkeyService: HotKeysService;

  private _commandProcessor: CommandProcessor;

  private _windowKeyboardShortcutController: WindowKeyboardShortcutController;

  public constructor(
    @inject(CORE_TYPES.HotKeysService) hotkeyService: HotKeysService,
    @inject(CORE_TYPES.CommandProcessor) commandProcessor: CommandProcessor,
    //TODO: [namazov] it should be moved to its own module
    @inject(TYPES.WindowKeyboardShortcutController) windowKeyboardShortcutController: WindowKeyboardShortcutController
  ) {
    this._hotkeyService = hotkeyService;
    this._commandProcessor = commandProcessor;
    this._windowKeyboardShortcutController = windowKeyboardShortcutController;
  }

  public init(): Promise<void> {
    this._windowKeyboardShortcutController.init();

    this._hotkeyService.registerHotKey('ctrl+z,cmd+z', () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
      this._commandProcessor.undo();
    });

    this._hotkeyService.registerHotKey('ctrl+shift+z,cmd+shift+z,ctrl+y', () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
      this._commandProcessor.redo();
    });

    return Promise.resolve();
  }
}
